<template>
  <div>
    <el-card body-style="padding: 0" v-show="isShowSearchBar">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">业务员公告</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="关键字" prop="noticeTitle">
              <el-input v-model="queryForm.noticeTitle" placeholder="请输入关键字"/>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <div slot="header" class="clearfix" v-show="!isShowSearchBar">
        <span style="color: #409EFF">业务员公告</span>
      </div>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="noticeTitle" label="标题">
          <template slot-scope="scope">
            <span v-show="scope.row.isNew" style="background-color: #04befe;color:white; width: 35px;padding: 5px;border-radius:5px ">最新</span>
            <span v-show="scope.row.isNeed" style="margin-left:5px;background-color: red;color:white; width: 35px;padding: 5px;border-radius:5px ">必读</span>
            <span v-show="scope.row.isTop" style="margin-left:5px;background-color: #04befe;color:white; width: 35px;padding: 5px;border-radius:5px;margin-right:5px;">置顶</span>
            <el-button type="text" @click.native="handleShow(scope.row)">{{ scope.row.noticeTitle }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间"/>
        <el-table-column prop="remarks" label="备注"/>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="120px">
        <el-form-item label="公告标题">
          <span style="color: black; font-size: medium">{{ dialogForm.noticeTitle }}</span>
        </el-form-item>
        <el-form-item label="发布时间">
          <div style="color: gray; font-size: x-small;margin-top: 2px;">{{ dialogForm.createTime }}</div>
        </el-form-item>
        <el-form-item label="发布内容">
          <div v-html="dialogForm.noticeContent"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="todayIsNotShow" size="mini">今日不再显示</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {queryNotice, updateNotice, updateNoticeIsNotToday} from "../../api/b2cbusiness/b2c_admin";

export default {
name: "SalemaneMessageList",
  props:{
    isShowSearchBar: {
      type: Boolean,
      default: true
    }
  },
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
      },
      dialogFormVisible: false,
      dialogTitle: "查看公告",
      dialogRefName: "dialogForm",
      dialogForm: {},
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
  this.getData();
  },
  methods: {
    todayIsNotShow(){
      this.dialogForm.isNotToday = true;
      updateNoticeIsNotToday(this.dialogForm.id).then(res=>{
        if (res.success){
          this.dialogFormVisible = false;
          this.getData();
        }
      });
    },
    handleShow(row) {
      this.dialogFormVisible = true;
      this.dialogForm = {...row}
    },
    getData() {
      queryNotice(this.queryForm, this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
          this.isNeedShow();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    isNeedShow(){
      for (let item in this.tableData){
        if (this.tableData[item].isShow && !this.isShowSearchBar && !this.tableData[item].isNotToday){
          this.handleShow(this.tableData[item])
        }
      }
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
